const routes = [
  {
    name: 'main',
    path: '/',
    meta: {
      authorization: {
        authenticated: true,
      },
    },
    component: () => import('@/views/Dashboard.vue'),
    children: [
      {
        name: 'home',
        path: '/',
        component: () => import('@/views/home/HomeView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'createRequest',
        path: '/request/new',
        component: () => import('@/views/request/CreateRequestView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'editRequest',
        path: '/request/:businessId',
        component: () => import('@/views/request/EditRequestView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'userProfile',
        path: '/profile',
        component: () => import('@/views/profile/UserProfileView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'administrate-users',
        path: '/administrateUsers',
        component: () => import('@/views/profile/AdminUserProfileView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'user-profile',
        path: '/user-profile/:userId',
        component: () => import('@/views/profile/UserProfileView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'my-profile',
        path: '/my-profile/:userId',
        component: () => import('@/views/profile/UserProfileView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'changeQuestion',
        path: '/profile/changeQuestion/:userId',
        component: () => import('@/views/profile/ChangeQuestionView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'changeRole',
        path: 'profile/changeRole/:userId',
        component: () => import('@/views/profile/ChangeRoleView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'tawkSupervisor',
        path: '/chat',
        component: () => import('@/views/chat/tawkSupervisor.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'emailDashboard',
        path: '/email-dashboard',
        component: () => import('@/views/email-dashboard/ActiveEmail.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'hideEmailDashboard',
        path: '/hide-email-dashboard',
        component: () => import('@/views/email-dashboard/HideEmail.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'reports',
        path: '/reports',
        component: () => import('@/views/reports/ReportsView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
      {
        name: 'authorizedRequestsReport',
        path: '/reports/authorized-requests',
        component: () => import('@/views/reports/AuthorizedRequestsView.vue'),
        meta: {
          authorization: {
            requiresAuth: true,
          },
        },
      },
    ],
  },
  //Full Layouts
  // {
  //   name: 'fullLayout',
  //   path: '/fullLayout',
  //   component: () => import('@/components/layout/TheFullLayout.vue'),
  //   meta: {
  //     authorization: {
  //       requiresAuth: true,
  //     },
  //   },
  //   children: [
  //     {
  //       name: 'AuthorizedLetter',
  //       path: '/request/authorized-letter/:businessId',
  //       component: () => import('@/views/request/AuthorizationLetterView.vue'),
  //       meta: {
  //         authorization: {
  //           requiresAuth: false,
  //         },
  //       },
  //     },
  //   ],
  // },
  {
    name: 'signin',
    path: '/signin',
    component: () => import('@/views/auth/SignIn.vue'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('@/views/register/RegisterView.vue'),
    meta: {
      authorization: {
        requiresAuth: false,
      },
    },
  },
  {
    name: 'createuser',
    path: '/create-user',
    component: () => import('@/views/register/CreateView.vue'),
    meta: {
      authorization: {
        requiresAuth: false,
      },
    },
  },
  {
    path: '*',
    redirect: { name: 'main' },
  },
];

export default routes;
